<!-- filepath: client/src/components/RatingComp.vue -->
<template>
  <div>

    <div class="page_loader_cont" v-if="page_loader">
        <div class="spinner_height">
            <spinner-circle :black="true"></spinner-circle>
        </div>
    </div>

    <div v-else class="rating-table-container">

      <!-- rate comment popup to show the full comment with close btn -->
      <div v-if="show_rate_comment_pop_up" id="popup" class="rate_comment_overlay">
        <div class="rate_comment_cont rate_comment_son">
          <h5>{{ comment_title }}</h5>

          <div class="rate_comment">
            {{ comment_to_show }}
          </div>

          <div class="actions">
            <button class="btn-cancel" @click="close_rate_comment()">Close</button>
          </div>
        </div>
      </div>

      <h2 v-if="role === 'social'">Rated Sessions (need to contact)</h2>
      <h2 v-else>Rated Sessions</h2>



    <!-- add response popup -->
    <div v-if="show_add_res_pop_up" id="popup" class="add_resp_overlay add_resp_cont">
      <div class="add_resp_cont add_res_son">
        <h3>Add Response</h3>

        <textarea id="response" placeholder="Write your response here..." v-model="response_text"></textarea>

        <div class="actions">
          <button class="btn-cancel" @click="close_add_res()">Cancel</button>
          <button class="btn-add" >
            
          
                  <div class="loading" v-if="add_loading">
                      <Spinner />
                  </div>
                  <div class="btn_txt" v-else @click="send_response()">Add</div>
          
          </button>
        </div>
      </div>
    </div>

      <table class="cool-table" v-if="ratedSessions && Array.isArray(ratedSessions) && ratedSessions.length > 0">
        <thead>
          <tr>
            <th>Parent</th>
            <th>Branch</th>
            <th>Sales</th>
            <th>Groomer</th>
            <th>Cashier</th>
            <th>Response</th>
            <th>Date</th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="sess in ratedSessions" :key="sess.id">
            <!-- Parent -->
            <td>
              <strong>{{ sess.Session.parent_name }}</strong><br>
              <small>{{ sess.Session.parent_phone }}</small>
            </td>

            <!-- Branch -->
            <td>
              <strong>
                {{ sess.branch === 'beverly_hills' ? 'Beverly hills' : (sess.branch === 'palm_hills' ? 'Palm hills' : sess.branch) }}
              </strong>

              <div class="row star_num_cont">
                <img class="star_admin" src="@/assets/normal_star.svg" alt="star">
                <div class="emp_rate">
                  {{ sess.branch_rate }}
                </div>
              </div>


              <!-- check if sess.branch_comment not null add pointer class -->
              

              <small @click="open_rate_comment('Comment about branch', sess.branch_comment)" :class="{ pointer: sess.branch_comment && sess.branch_comment.trim() }">{{ truncateText(sess.branch_comment, 3) || '--' }}</small>
            </td>

            <!-- Sales -->
            <td>
              <strong>{{ sess.Sales.sales_name }}</strong>

              <div class="row star_num_cont">
                <img class="star_admin" src="@/assets/normal_star.svg" alt="star">
                <div class="emp_rate">
                {{ sess.sale_rate }}
                </div>
              </div>

              <small @click="open_rate_comment('Comment about sales', sess.sales_comment)" :class="{ pointer: sess.sales_comment && sess.sales_comment.trim() }">{{ truncateText(sess.sales_comment, 3) || '--' }}</small>
            </td>

            <!-- Groomer -->
            <td>
              <strong>{{ get_groomer_name(sess) }}</strong>

              <div class="row star_num_cont">
                <img class="star_admin" src="@/assets/normal_star.svg" alt="star">
                <div class="emp_rate">
                {{ sess.SessionGroomerRating?.groomer_rate }}
                </div>
              </div>

              <small @click="open_rate_comment('Comment about groomer', sess.SessionGroomerRating?.groomer_comment)" :class="{ pointer: sess.SessionGroomerRating?.groomer_comment && sess.SessionGroomerRating?.groomer_comment.trim() }">{{ truncateText(sess.SessionGroomerRating?.groomer_comment, 3) || '--' }}</small>
            </td>

            <!-- Cashier -->
            <td>
              <strong>{{ sess.Cashier.cashier_name }}</strong>
              <br>
              <div class="row star_num_cont">
                      <img class="star_admin" src="@/assets/normal_star.svg" alt="star">
                      <div class="emp_rate">
                        {{ sess.cashier_rate }}
                      </div>
              </div>


              <small @click="open_rate_comment('Comment about cashier', sess.cashier_comment)" :class="{ pointer: sess.cashier_comment && sess.cashier_comment.trim() }">{{ truncateText(sess.cashier_comment, 3) || '--' }}</small>
            </td>

              <td>
                <div v-if="sess.response && sess.response.length > 0" class="pointer" @click="open_rate_comment('Client response', sess.response)">{{ truncateText(sess.response, 3) }}</div>
                <div v-else class="add_btn" @click="open_add_response(sess.id)"><span v-if="role !== 'owner'">Add</span></div>
              </td>

            <!-- Date -->
            <td>
                {{ new Date(sess.createdAt).toLocaleDateString() }}<br>
                <small>{{ new Date(sess.createdAt).toLocaleTimeString() }}</small>
            </td>
          </tr>
        </tbody>
      </table>

      <div v-else class="no_result no_result_center">You don’t have any ratings yet.</div>


    </div>

  </div>
</template>

<script>
import request from '../axios_request';
import { mapState  } from 'vuex';
import Spinner from '@/components/Spinner.vue';
import SpinnerCircle from './SpinnerCircle.vue';



export default {
  name: "RatingComp",
  components: {
      SpinnerCircle,
      Spinner
  },
  data() {
    return {
      page_loader: true,
      ratedSessions:null,
      show_add_res_pop_up: false,
      add_loading: false,
      response_text: null,
      current_id: null,
      comment_to_show: null,
      show_rate_comment_pop_up: false,
      comment_title: null,
    };
  },
    created() {
        // Fetch rated sessions from server (to be implemented) /get_all_ratings
        request.get('/api/rating/get_all_ratings')
        .then((response) => {
            if (response.status === 200) {
                this.ratedSessions = response.data;
                this.page_loader = false;
                console.log("Fetched rated sessions:", response.data);
            }
        })
        .catch((error) => {
            console.error("Error fetching rated sessions:", error);
        });
    },
    methods:{
      open_add_response(id){
        this.current_id = id;
        this.show_add_res_pop_up = true;
        this.response_text = null;
        console.log("Opening add response popup for session ID:", id);
      },
      //if groomer_name is null return get groomer name from multi_groomers but convert it to array first then return the groomer with the same id as SessionGroomerRating.groomer_id
      get_groomer_name(sess){
        //if multi_groomers is not null convert it to json
        if (typeof sess.Session.multi_groomers === 'string') {
          try {
            sess.Session.multi_groomers = JSON.parse(sess.Session.multi_groomers);
          } catch (error) {
            console.error("Error parsing multi_groomers:", error);
            sess.Session.multi_groomers = [];
          }
        }
        if(sess.Session.groomer_name){
          return sess.Session.groomer_name;
        }else if(sess.Session.multi_groomers && Array.isArray(sess.Session.multi_groomers)){
          const groomer = sess.Session.multi_groomers.find(g => g.groomer_id === sess.SessionGroomerRating.groomer_id);
          return groomer ? groomer.groomer : 'N/A';
        }else{
          return 'N/A';
        }
      },
      send_response(){
        if( !this.response_text ){
          alert('Please enter a response 1.');
          return;
        }
        if (!this.response_text.trim()) {
          alert('Please enter a response 2.');
          return;
        }
        console.log(this.response_text);
        this.add_loading = true;
        request.post('/api/rating/send_res', {
          id: this.current_id,
          reso: this.response_text
        })
        .then((response) => {
          if (response.status === 200) {
            console.log("Response sent successfully:", response.data);
            this.show_add_res_pop_up = false;
            this.response_text = '';
            this.current_id = null;
            // Optionally refresh the list
            this.fetchRatedSessions();
          }
        })
        .catch((error) => {
          console.error("Error sending response:", error);
          alert('Failed to send response. Please try again.');
        })
        .finally(() => {
          this.add_loading = false;
        });
      },

      fetchRatedSessions() {
        // Fetch rated sessions from server
        request.get('/api/rating/get_all_ratings')
          .then((response) => {
            if (response.status === 200) {
              this.ratedSessions = response.data;
              this.page_loader = false;
              console.log("Fetched rated sessions:", response.data);
            }
          })
          .catch((error) => {
            console.error("Error fetching rated sessions:", error);
          });
      },

      close_add_res(){
        this.show_add_res_pop_up = false;
      },

      truncateText(text, length = 10) {
        if (!text) return '';
        return text.length > length
          ? text.slice(0, length) + '...'
          : text;
      },

      open_rate_comment(title, comment){
        if( !title || !comment ){
          return;
        }
        this.comment_to_show = comment;
        this.show_rate_comment_pop_up = true;
        this.comment_title = title;
      },

      close_rate_comment(){
        this.show_rate_comment_pop_up = false;
      }
    },
    computed: {
        ...mapState([
            'role',
            'admin_name',
            'company_logo',
            'company',
            'branch'
        ]),
      }
};
</script>

<style scoped>
.rating-table-container {
  padding: 24px;
  /* background: #f9f9f9; */
  border-radius: 12px;
  /* box-shadow: 0 2px 8px rgba(0,0,0,0.07); */
}
.cool-table {
  width: 100%;
  border-collapse: collapse;
  background: white;
  border-radius: 8px;
  overflow: hidden;
}
.cool-table th, .cool-table td {
  padding: 12px 16px;
  text-align: left;
}
.cool-table th {
  background: #4f8cff;
  color: white;
}

/* .cool-table tr:nth-child(even) {
  background: #f9fafb;
} */

.cool-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.cool-table th {
  background: #317BEB;
  text-align: left;
  padding: 12px;
  font-weight: 600;
}

.cool-table td {
  padding: 12px;
  vertical-align: top;
  border-bottom: 1px solid #e5e7eb;
}

.cool-table small {
  color: #6b7280;
}

.cool-table tr:hover {
  background: #f9fafb;
}

.star_num_cont{
  align-items: center;
}

.star_admin{
  height: 15px;
}

.emp_rate{
  margin-left: 5px;
  font-weight: 500;
}

.add_btn{
  cursor: pointer;
  color: #317BEB;
  font-weight: 500;
  display: inline-block;
}

.add_btn:hover{
  text-decoration: underline;
}


/* Overlay background */
.add_resp_overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;


}

/* Popup container */
.add_resp_cont {
  background: #fff;
  width: 420px;
  max-width: 90%;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.25);
  animation: popupFade 0.25s ease;


}

.add_resp_cont h3 {
  margin-bottom: 12px;
  font-size: 18px;
  color: #333;
}

/* Textarea */
.add_resp_cont textarea {
  width: 100%;
  min-height: 120px;
  padding: 12px;
  border-radius: 8px;
  border: 2px solid #ccc;
  resize: none;
  font-size: 14px;
  outline: none;
}

.add_resp_cont textarea:focus {
  border-color: #317BEB;
  /* box-shadow: 0 0 0 2px rgba(49, 123, 235, 0.15); */
}

/* Buttons */
.actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 15px;
}

.actions button {
  padding: 10px 18px;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  font-size: 14px;
}

/* Add button */
.btn-add {
  background: #317BEB;
  color: #fff;
}

.btn-add:hover {
  background: #2668d6;
}

/* Cancel button */
.btn-cancel {
  background: #f1f1f1;
  color: #333;
}

.btn-cancel:hover {
  background: #e2e2e2;
}

/* Animation */
/* @keyframes popupFade {
  from {
    transform: scale(0.95);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
} */


.add_resp_overlay{
  background-color: #0000006e;
  width: 100%;
  position: fixed;
  left: 0px;
  max-width: 100%;
  border-radius: 0px;
}

.pointer{
  cursor: pointer;
}

.rate_comment_overlay{
  background-color: #0000005c;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0px;
  left: 0px;
  max-width: 100%;
  border-radius: 0px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.rate_comment_cont{
  background-color: white;
  padding: 20px;
  max-width: 500px;
  width: 100%;
  margin-top: 10vh;
  border-radius: 3px;
}

.rate_comment_cont h5 {
  margin-bottom: 12px;
  /* font-size: 18px; */
  color: #333;
  margin-top: 5px;
}

@media (max-width: 900px) {
  .cool-table,
  .cool-table thead,
  .cool-table tbody,
  .cool-table th,
  .cool-table td,
  .cool-table tr {
    display: block;
    background-color: transparent;
  }



  .cool-table thead {
    display: none;
  }

  .cool-table tr {
    margin-bottom: 16px;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    padding: 12px;
    background: #fff;
  }

  .cool-table td {
    border: none;
    padding: 6px 0;
  }
}

</style>